module.exports = __webpack_public_path__ + "static/media/YM47_5.ba5449b4.jpg";